import $ from 'jquery';

export default function (params) {

	let $this,
		config = {
			selectBlock: '',
			selectId: ''
		},
		$viewAir,
		$iconAir,
		$select,
		$listAir,
		$document = $(document),
		mAir = {};

	/**
	 * Metod init
	 */
	function init() {

		$this = $(config.selectBlock);
		$select = $(config.selectId, $this);
		$viewAir = $('.js_airport-view', $this);
		$iconAir = $('.js_airport-icon', $this);
		$listAir = $('.js_airport-view-list', $this);

		initSelect();
		subscription();
		renderViewAir();
		//$('.c-airport__list-view', $this).mCustomScrollbar();
	}
	/**
	 * Metod InitSelect
	 */
	function initSelect() {
		let m = [];
		$select.find('option').each(function () {

			mAir[this.value] = this.text;

			m.push({
				name: this.text,
				v: this.value
			});
		});

		renderListAirport(m);
	}
	/**
	 * event
	 */
	function subscription() {
		$viewAir.on('click', openClose);
		$iconAir.on('click', openClose);
		$listAir.on('click', '.c-airport-item', function (ev) {

			let currentAir = $(this).data('air');
			changeAir(currentAir);
			hidden();
		});
	}
	/**
	 * metod subscription click - document
	 */
	function clickGlobal() {
		setTimeout(function () {

			$document.on('click', testClickClobal);

		}, 30);
	}
	function testClickClobal(ev) {
		if (!$(ev.target).closest('.c-airport-view').length == 1) {
			hidden();
		}
	}
	function unClickGlobal() {
		$document.off('click', testClickClobal);
	}
	/**
	 * Metod openClose air
	 */
	function openClose() {
		if ($this.hasClass('_visible_list-airports')) {
			hidden();
		} else {
			show();
		}
	}
	/**
	 * metod hidden
	 */
	function hidden() {
		$this.removeClass('_visible_list-airports');
		unClickGlobal();
	}
	/**
	 * metod show calendar
	 */
	function show() {
		setStyle();
		$this.addClass('_visible_list-airports');
		clickGlobal();
	}
	/**
	 * Metod get Value Select
	 */
	function getValue() {
		return $select.val();
	}
	/**
	 * metod changeAir
	 */
	function changeAir(currentAir) {
		selectFalse();
		$select.find("[value='" + currentAir + "']").prop("selected", true);
		renderViewAir();
	}
	/**
	 * metod $selected false 
	 */
	function selectFalse() {
		$select.find('option:selected').each(function () {
			$(this).prop('selected', false);
		});
	}
	/**
	 * Metod set selected style
	 */
	function setStyle() {
		let currentAir = getValue();

		$listAir.find('._active-select').removeClass('_active-select');
		$listAir.find('[data-air=' + currentAir + ']').addClass('_active-select');
	}











	/**
	 * Metod renderVieAi
	 */
	function renderViewAir() {
		let currentAir = getValue();

		$viewAir.html('<span class="c-airport-item__title">' + mAir[currentAir] + '</span>' +
			'<span class="c-airport-item__short">- ' + currentAir + '</span>');
	}
	/**
	 * metod render List Airport
	 */
	function renderListAirport(m) {
		let contentHtml = '';

		m.forEach(function (o) {
			contentHtml += '<li data-air="' + o.v + '" class="c-airport-item c-airport-view__li">' +
				'<span class="c-airport-item__title">' + o.name + '</span>' +
				'<span class="c-airport-item__short">- ' + o.v + '</span>' +
				'</li>'
		});


		$listAir.html(contentHtml);
	}

	$.extend(true, config, params || {});
	init();
}


// WEBPACK FOOTER //
// ./widget/select-airport.js